import React from "react";
import Header from "../Components/Header";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
    </>
  );
};

export default React.memo(Layout);
